import React from 'react'
import './goods-operation.less'
// import * as math from 'mathjs'
class GoodsOperation extends React.Component<any, any> {
  render() {
    return (
      <div className="goods-operation">
        <img
          className="good-decrease"
          src={process.env.PUBLIC_URL + '/assets/img/good-decrease.png'}
          alt="anxin.png"
          onClick={() => this.props.decrease(this.props.goods.goods_id)}
        />

        <div className="num"> {this.props.goods.num}</div>
        <img
          className="good-increase"
          src={process.env.PUBLIC_URL + '/assets/img/good-increase.png'}
          alt="anxin.png"
          onClick={() => this.props.increase(this.props.goods.goods_id)}
        />
      </div>
    )
  }
}
export default GoodsOperation
